export default "/images/edit-outline.svg?2b831c5faab2302715c159f7666b2f3b";